var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFilePdf = function SvgFilePdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BA0C2F",
    d: "M15 0H4.125A1.12 1.12 0 0 0 3 1.12v21.755A1.12 1.12 0 0 0 4.12 24h15.755A1.123 1.123 0 0 0 21 22.88V6h-5.25a.75.75 0 0 1-.75-.75z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BA0C2F",
    d: "M21 5.714V6h-5.25a.75.75 0 0 1-.75-.75V0h.286a1.13 1.13 0 0 1 .797.328l4.589 4.594a1.12 1.12 0 0 1 .328.792M3 14h18v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCE8EF",
    d: "M7.612 18.552h.39q.648 0 .648-.564t-.648-.564h-.39zm0 2.448H6.436v-4.524h1.872q.762 0 1.164.396.408.396.408 1.116t-.408 1.116q-.402.396-1.164.396h-.696zM11.678 20.004h.27q.306 0 .546-.096a1.14 1.14 0 0 0 .654-.66q.09-.234.09-.51 0-.27-.09-.504a1.14 1.14 0 0 0-.66-.666 1.4 1.4 0 0 0-.54-.096h-.27zm-1.176-3.528h1.74q.462 0 .864.186.408.186.708.498.306.306.48.72.174.408.174.858 0 .444-.174.858-.168.408-.474.72-.3.312-.708.498a2.05 2.05 0 0 1-.87.186h-1.74zM17.811 17.472h-1.416v.756h1.29v.996h-1.29V21H15.22v-4.524h2.592z"
  }))));
};
export default SvgFilePdf;